import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatabaseGwService } from '../../../rds-objects/services/database-gw.service';
import { UploadImageService } from '../../../rds-utilities/upload-image.service'; 

@Component({
	selector: 'rds-upload-image',
	templateUrl: './upload-image.component.html',
	styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {

	@Input() record: any; //Required
	@Input() title: string = 'Add photos';
	@Input() subtitle:string = "or drag and drop";
	@Input() clientName: string = "portal";
	@Input() userInfo: any = {};//required
	@Input() disable: boolean = false;//TBD
	@Input() folder: string = 'photos';
	
	@Input() displayAs:string = "inline"; //default: inline | Options: inline, popup
	@Input() aspectRatio: string = "";//default: "" | Options: "1:1", "1:2", "2:3", " 3:2", "3:4", "4:3", "4:5", "9:16", "16:9"
	@Input() displayRatio: string = "16:9";//default: "16:9" | Options: "1:1", "1:2", "2:3", " 3:2", "3:4", "4:3", "4:5", "9:16", "16:9"
	@Input() buttonTitle:string = "Upload Photo";


	@Input() frameSize: string = '';//xs, sm (default), md,
	@Input() manualUpload: boolean = true;// to show button upload image
	@Input() fromAction: string = 'all';//e.g. thumb-product
	@Input() is360:boolean = false;
	@Input() watermark:boolean = false;
	@Input() photoFieldOpt:any = {};

	// For single upload image
	@Input() photoField: string = "photo";
	@Input() uploadOnSelect: boolean = false;

	// For multiple upload image
	@Input() multiple: boolean = false;
	@Input() listPhotos: any[] = [];
	@Input() existedPhotos: any[] = [];
	@Input() showListPhoto:boolean = true;

	@Output() callback: EventEmitter<any> = new EventEmitter();//event after image uplaoded
	// @Output() recordChange: EventEmitter<any> = new EventEmitter();
 
	@ViewChild("popupTemplate", { static: false }) template: TemplateRef<any>;

	imageName: string = ""
	files: File[] = [];
	lstMultiFiles:any[] = [];
	activeFile: File;
	// userInfo: User = new User();
	isSaving: boolean = false;
	isDeleting: boolean = false;
	lstAspectRatios: string[] = ["1:1", "1:2", "2:3", " 3:2", "3:4", "4:3", "4:5", "9:16", "16:9"];

	constructor(@Inject('env') private $env,
		private $http: HttpClient,
		private $database: DatabaseGwService,
		private $uploadImage: UploadImageService,
		public $dialog: MatDialog
	) { }

	ngOnInit() {
		this.$uploadImage.saveImageTrigger.subscribe(fromAction => {
			if (this.fromAction == "all" || fromAction == this.fromAction) {
				this.doUploadObjectImageField();
			}
		}); 
		this.clientName = this.$env.client;
		// console.log("record", this.record);
	}

	onSelect(event: any) {  
		this.files = [];
		this.files.push(...event.addedFiles);
		this.activeFile = event.addedFiles[0];
		this.record[this.photoField + '_file'] = {name: this.activeFile.name}; 
		
		if(!this.multiple && !this.manualUpload){
			this.doUploadObjectImageField();
		}
	}

	onSelectMultiPhoto(event:any){ 
		this.lstMultiFiles = []; 

		event.addedFiles.forEach(file => {
			this.lstMultiFiles.push({
				uploading: true,
				file: file
			}); 
		});
		if (!this.manualUpload) {
			this.uploadPhotos(event.addedFiles);
		}
	}

	onRemove(f:any){

	}

	doUploadObjectImageField() {
		this.isSaving = true;
		let uploadStatus: any = {
			status: "error",
			message: (!this.userInfo.api_token ? "User Unauthorize!" : "Invalid File! Refresh your browser."),
		}
		 
		//we allow only user has auth and there are a file
		if (this.activeFile && this.activeFile.name && this.userInfo.api_token) {
			let imagePath: string = `${this.clientName}/${this.folder}`;
			  
			let formData: FormData = new FormData();  
			formData.append("path", imagePath);
			formData.append("file", this.activeFile);
			formData.append("watermark", (this.watermark ? "1" : "0"));
			formData.append("ep", this.$env.STORAGE_EP); 
			formData.append("storage", this.$env.STORAGE ? this.$env.STORAGE : 'local'); 

			if (this.aspectRatio && this.aspectRatio != "") {
				formData.append("aspectRatio", this.aspectRatio);
			} 
			let httpOptions: any = this.generateHttpOption();

			this.$http.post(this.$env.UPLOAD_IMG_EP, formData, httpOptions).subscribe((res:any) => {
				 
				uploadStatus.status = "success";
				uploadStatus.message = res.message;
				uploadStatus.photoname = res.photoname;
				uploadStatus.thumbname = res.thumb; 
 
				this.isSaving = false;
				this.callback.emit(uploadStatus);
				//return result to parent
				
			}, err => { 
				uploadStatus.message = err.error.message;
				this.isSaving = false;
				this.callback.emit(uploadStatus);
			});
		} else { 
			this.isSaving = false;
			this.callback.emit(uploadStatus);
		}
	}

	doUploadMultiplePhoto(){
		let lstFiles:File[] = [];
		this.lstMultiFiles.forEach(f => {
			if(f.uploading){
				lstFiles.push(f.file);
			}
			
		});
		if(lstFiles && lstFiles.length){
			this.uploadPhotos(lstFiles);
		}
		
	}
	uploadPhotos(files:File[]) {
		this.isSaving = true;
		let uploadStatus: any = {
			status: "error",
			message: (!this.userInfo.api_token ? "User Unauthorize!" : "Invalid Token! Refresh your browser."),
		} 
		
		let imagePath: string = `${this.clientName}/${this.folder}`;

		const formData: FormData = new FormData(); 
		formData.append("path", imagePath);
		// formData.append("parentid", (this.record && this.record.id ? this.record.id : null));
		formData.append("watermark", (this.watermark ? "1" : "0"));
		formData.append("is_pano", (this.is360 ? "1" : "0"));
		formData.append("ep", this.$env.STORAGE_EP); 
		formData.append("storage", this.$env.STORAGE ? this.$env.STORAGE : 'local'); 
		

		for (const col in this.photoFieldOpt) {
			const val = this.photoFieldOpt[col];
			console.log("col", col, val);
			formData.append(col, val);
		}

		
		if (this.aspectRatio && this.aspectRatio != "") {
			formData.append("aspectRatio", this.aspectRatio);
		}

		//we allow only user has auth and there are a file
		if (files && files.length && this.userInfo.api_token) {
			
			// add all files into request
			files.forEach(file => {
				formData.append("files[]", file);
			});

			let httpOptions: any = this.generateHttpOption();
 
			this.$http.post(this.$env.UPLOAD_MASS_IMG_EP, formData, httpOptions).subscribe((res:any) => {
				uploadStatus.status = "success";
				uploadStatus.message = res.message; 
				uploadStatus.photos = res.photos;

				this.existedPhotos.push(...res.photos);
				// disable loading
				this.isSaving = false;
				this.lstMultiFiles = []; 

				this.callback.emit(uploadStatus);
			}, err => { 
				uploadStatus.message = err.error.message; 
				console.log("res err", err);
				this.isSaving = false;
				this.callback.emit(uploadStatus);
			});
		} else {
			this.isSaving = false;
			uploadStatus.message = "File is required!";
			this.callback.emit(uploadStatus);
		}
	}

	onDeletePhoto(record: any, index: number) {
		if (record && record.id) { 
			this.existedPhotos[index].is_deleting__c = true;
			this.$database.delete(record, "/photos").subscribe(res => {
				this.existedPhotos.splice(index, 1); 
			});
		}
	}

	createPhoto(uploadStatus){
		this.isSaving = true;
		let photoRecord: any = {}; 
		photoRecord.photo = uploadStatus.photoname;
		photoRecord.thumbnail = uploadStatus.thumbname;
		photoRecord.parent_id = this.record && this.record.id ? this.record.id : null;
		photoRecord.is_pano = this.is360;

		let httpOptions: any = this.generateHttpOption();

		this.$database.create(photoRecord, "/photos", httpOptions).subscribe(respond => {
			if (!this.record.photos) {
				this.record.photos = [];
			}
			let rec: any = {};
			Object.assign(rec, respond.data[0]);
			rec.photo_preview = rec.photo;
			this.record.photos.unshift(rec);
			// this.files = [];
			this.activeFile = null;
			this.isSaving = false;

			uploadStatus.photos = this.record.photos;
			this.callback.emit(uploadStatus); 
		}, error => {
			this.isSaving = false;
			// this.$snackBar.error(error.message);
			uploadStatus.status = "error";
			uploadStatus.message = error.message;
			this.callback.emit(uploadStatus); 
		});
	}

	generateHttpOption(){
		return {
			headers: new HttpHeaders({
				"Authorization": `Bearer ${this.userInfo.api_token}`,
				"client": this.clientName
			})
		};
	}

	openDialogUploadPhoto(){
		const dialogRef = this.$dialog.open(this.template, {width: '90vw', height: '90vh'});

		dialogRef.afterClosed().subscribe(result => {
		  console.log(`Dialog result: ${result}`);
		});
	}
}
